import {
  IonPage,
  IonHeader,
  IonToolbar,
  IonButtons,
  IonBackButton,
  IonTitle,
  IonItem,
  IonContent,
  IonList,
  IonLabel,
  IonText,
  IonSelect,
  IonSelectOption,
  IonLoading,
  IonRow,
  IonCol,
  IonIcon,
} from "@ionic/react";
import React, { useEffect, useState } from "react";
import classes from "./SupportTicket.module.css";
import axios from "axios";
import { requestID, baseUrl, config } from "../../../common/utils";
import { formatDateToLocal } from "../../../libs/lib";
import { arrowBack, chatbox, umbrellaOutline } from "ionicons/icons";

const SupportTicket = () => {
  const [supportTicket, setSupportTicket] = useState([]);
  const [filteredSupportTicket, setfilteredSupportTicket] = useState([]);
  const [selectedStatus, setSelectedStatus] = useState("");
  const [status, setStatus] = useState({ loading: false, error: false });

  const getSupportTicket = async () => {
    setStatus({ loading: true, error: false });
    try {
      const formData = new FormData();
      formData.append("requestID", requestID());
      const response = await axios.post(
        baseUrl() + "Supports/getAllSupportTickets",
        formData,
        config
      );

      const data = response.data.data;
      console.log(data);
      setStatus({ loading: false, error: false });
      setSupportTicket(data);
      setfilteredSupportTicket(data);
    } catch (error) {
      setStatus({ loading: false, error: true });
    }
  };

  useEffect(() => {
    getSupportTicket();
    return () => {};
  }, []);

  useEffect(() => {
    if (selectedStatus === "") {
      // If no status is selected, show all tickets
      setfilteredSupportTicket(supportTicket);
    } else {
      const filtered = supportTicket?.filter(
        (ticket) => ticket?.status === selectedStatus
      );
      setfilteredSupportTicket(filtered);
    }
  }, [selectedStatus, supportTicket]);

  // const filteredTickets = supportTicket?.filter(
  //   (ticket) => ticket?.status == selectedStatus
  // );

  return (
    <IonPage>
      <IonHeader>
        <IonToolbar>
        <IonButtons slot="">
            <IonBackButton text="" icon={arrowBack} className="zillytheme2" />
          </IonButtons>
          <IonTitle> Support Ticket Management</IonTitle>
        </IonToolbar>
      </IonHeader>
      <IonContent className="ion-padding">
        {/* selcet  */}
        <IonItem lines="none">
          <IonSelect
            label={`Complaints (${2})`}
            placeholder={`All complaints`}
            value={selectedStatus}
            onIonChange={(e) => setSelectedStatus(e.detail.value)}
          >
            <IonSelectOption value="">complaints</IonSelectOption>
            <IonSelectOption value="1">Open</IonSelectOption>
            <IonSelectOption value="0">closed</IonSelectOption>
          </IonSelect>
        </IonItem>

        <IonList>
          {filteredSupportTicket?.map((ticket, i) => {
            return (
              <div key={i}>
                <IonItem
                  button={ticket?.status === "1"}
                  key={i}
                  lines="none"
                  className={`zillyBoxc ${classes.support_itemcontainer}`}
                  routerLink={
                    ticket?.status === "1"
                      ? `supportTicket/${ticket?.ticket_id}`
                      : undefined
                  }
                >
                  <div>
                    <IonLabel>{ticket?.name}</IonLabel>
                    <br />
                    <IonLabel>Ticket no.{ticket?.ticket_id}</IonLabel>
                    <span>{formatDateToLocal(ticket?.date)} </span>
                  </div>
                  {ticket?.status == "1" ? (
                    <IonText className={classes.support_openstatus} slot="end">
                      Open
                    </IonText>
                  ) : (
                    <IonText
                      className={classes.support_closedstatus}
                      slot="end"
                    >
                      Closed
                    </IonText>
                  )}
                </IonItem>
              </div>
            );
          })}
          {filteredSupportTicket.length <= 0 && (
            <div className={classes.noProduct_container}>
              <IonText className={classes.noProduct_text}>
                You have no Ticket yet, <br />
              </IonText>
              <IonIcon
                className={classes.noProduct_icon}
                // size="large"
                icon={chatbox}
              ></IonIcon>
            </div>
          )}
        </IonList>
        <IonLoading isOpen={status.loading} />
      </IonContent>
    </IonPage>
  );
};

export default SupportTicket;
